import { useMemo } from 'react';
import type { VoidFunctionComponent } from 'react';

import { window } from '../../../globals';
import useIsLicenseConcludedEnabled from '../../../hooks/features/useIsLicenseConcludedEnabled';
import LabeledCheckmark from '../../generic/LabeledCheckmark';
import { STANDARD_REPORT_OPTIONS } from '../constants';

import styles from './StandardOptions.module.less';

export const StandardOptions: VoidFunctionComponent = () => {
  const isLicenseConcludedEnabled = useIsLicenseConcludedEnabled(window?.user?.organizationId ?? 0);

  const visibleOptions = useMemo(
    () => STANDARD_REPORT_OPTIONS.filter(
      (option) => isLicenseConcludedEnabled || option.id !== 'includeConcludedLicenses',
    ),
    [isLicenseConcludedEnabled],
  );

  return (
    <div>
      <h4 className={styles.heading}>Included by FOSSA</h4>
      <div className={styles.list}>
        {visibleOptions.map((option) => (
          <LabeledCheckmark
            key={option.id}
            id={option.id}
            label={option.label}
            tooltip={option.tooltip}
            tooltipPlacement="left"
          />
        ))}
      </div>
    </div>
  );
};
